import { render, staticRenderFns } from "./premium-ax-list.vue?vue&type=template&id=3a698827&"
import script from "./premium-ax-list.vue?vue&type=script&lang=js&"
export * from "./premium-ax-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports